<template>
    <v-content>
        <v-container fill-height fluid class="app_container">
            <router-view></router-view>
        </v-container>
    </v-content>

</template>


<script>

    export default {}
</script>
